var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.componentName,
    _vm._b(
      {
        tag: "component",
        attrs: {
          clientType: _vm.clientType,
          email: _vm.$route.query.email,
          requestKey: _vm.$route.query.key,
          error: _vm.errorMessage,
          success: _vm.successMessage,
          form: _vm.form,
        },
      },
      "component",
      _vm.$route.query,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }